import { create } from 'zustand';

const useIndicesStore = create((set) => ({
  indices: [],
  setIndices: (newIndices) => set({ indices: newIndices }),
}));

export default useIndicesStore;
